import { ref } from 'vue'

/**
 * Shared open-state for the plan-upsell modal, settable from non-component
 * code (e.g. block-module `onGatedAdd` hooks). A single `UpsellModal` host
 * bound to this ref must be mounted on the surface that triggers it.
 */
export const isUpsellModalOpen = ref(false)

/** Opens the plan-upsell modal hosted on the current surface. */
export const openUpsellModal = (): void => {
  isUpsellModalOpen.value = true
}
